import React, {Component} from 'react';
import {Carousel, CarouselCaption, CarouselControl, CarouselIndicators, CarouselItem} from 'reactstrap';
import {
    BrowserView,
    MobileView,
    TabletView,
    isBrowser,
    isMobile
} from 'react-device-detect';

const items = [

    {
        id: 1,
        altText: '',
        caption: '',
        //src: 'assets/images/terbaru.jpg'
        src: 'assets/images/Gambar21.jpg'
    },
    {
        id: 2,
        altText: '',
        caption: '',
        // src: 'https://www.lintasarta.net/wp-content/uploads/2019/04/x31-tahun-header-1.jpg.pagespeed.ic.10nV3jaHww.webp'
        //src: 'assets/images/Gambar21.jpg'
        src: 'assets/images/Gambar31.jpg'
    },
    {
        id: 3,
        altText: '',
        caption: '',
        //src: 'assets/images/Gambar31.jpg'
        src: 'assets/images/Gambar41.jpg'
    },
    {
        id: 4,
        altText: '',
        caption: '',
        // src: 'https://www.lintasarta.net/wp-content/uploads/2018/08/xbg_who_we_are.jpg.pagespeed.ic.3xWvEWonZY.webp'
        //src: 'assets/images/Gambar41.jpg'
        src: 'assets/images/Gambar51.jpg'
    }
];

// BUM
// const items = [

//     {
//         id: 1,
//         altText: '',
//         caption: '',
//         src: 'assets/images/slide/bum/bum-slide-1.jpeg'
//     },
//     {
//         id: 2,
//         altText: '',
//         caption: '',
//         // src: 'https://www.lintasarta.net/wp-content/uploads/2019/04/x31-tahun-header-1.jpg.pagespeed.ic.10nV3jaHww.webp'
//         src: 'assets/images/slide/bum/bum-slide-2.jpg'
//     },
//     {
//         id: 3,
//         altText: '',
//         caption: '',
//         src: 'assets/images/slide/bum/bum-slide-3.jpg'
//     },
//     {
//         id: 4,
//         altText: '',
//         caption: '',
//         // src: 'https://www.lintasarta.net/wp-content/uploads/2018/08/xbg_who_we_are.jpg.pagespeed.ic.3xWvEWonZY.webp'
//         src: 'assets/images/slide/bum/bum-slide-4.jpg'
//     }
// ];

// fin Logistics
// const items = [
//     {
//         id: 1,
//         altText: '',
//         caption: '',
//         src: 'assets/images/slide/fin/fin-slide-2.jpg'
//     },
//     {
//         id: 2,
//         altText: '',
//         caption: '',
//         src: 'assets/images/slide/fin/fin-slide-1.jpg'
//     },
//     {
//         id: 3,
//         altText: '',
//         caption: '',
//         src: 'assets/images/slide/fin/fin-slide-3.jpg'
//     },
//     {
//         id: 4,
//         altText: '',
//         caption: '',
//         src: 'assets/images/slide/fin/terbaru.jpg'
//     }
// ];

class CarouselImage extends Component {
    constructor(props) {
        super(props);
        this.state = {activeIndex: 0};
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }

    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }

    next() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({activeIndex: nextIndex});
    }

    previous() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
        this.setState({activeIndex: nextIndex});
    }

    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({activeIndex: newIndex});
    }

    render() {
        const {activeIndex} = this.state;
        const body = document.body,
            html = document.documentElement;

        const height = Math.max( body.scrollHeight, body.offsetHeight, 
                            html.clientHeight, html.scrollHeight, html.offsetHeight );

        const slides = items.map((item) => {
            return (
                <CarouselItem
                    key={item.id}
                    onExiting={this.onExiting}
                    onExited={this.onExited}>
                    <BrowserView>
                        <img src={item.src} height={height} width="100%" alt={item.altText}/>
                    </BrowserView>
                    <TabletView>
                        <img src={item.src} height="100%" width="100%" alt={item.altText}/>
                    </TabletView>
                    <MobileView>
                        <img src={item.src} height="100%" width="100%" alt={item.altText}/>
                    </MobileView>
                    <CarouselCaption className="text-danger" captionText={item.altText} captionHeader={item.caption}/>
                </CarouselItem>
            );
        });

        return (
            <Carousel
                activeIndex={activeIndex}
                next={this.next}
                previous={this.previous}>
                <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex}/>
                {slides}
                <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous}/>
                <CarouselControl direction="next" directionText="Next" onClickHandler={this.next}/>
            </Carousel>
        );
    }
}

export default CarouselImage;


// WEBPACK FOOTER //
// ./containers/CarouselImage.js